class AnimationConstructor {
    constructor(container, props = {}) {
        this.props = props;
        this.options = {
            scrollDistance: 0,
            fullscreen: false,
            pin: false,
            markers: false,
            detectionMode: {
                start: 'top',
                end: 'bottom'
            },
            scrollTop: 0,
            start: 0,
            end: 0,
            ...props.options
        };

        this.elements = {
            container
        };

        this.scrollCords = {
            startAt: 0,
            endAt: 0
        };

        this.progress = 0;
        this.previousProgress = 0;
        this.progressReverse = 0;
        this.progressEnded = false;
        this.hasStarted = false;
        this.hasCompleted = false;
        this.hasStartedReverse = false;

        this.customAnimations = {};
        this.interfaceReady = false;
        this._cachedViewportValues = null;
        this._eventDetailPool = null;
    }
}

export default AnimationConstructor;